/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 0.999878L8.16 1.11988C9.53703 2.15265 10.2256 2.66904 10.9817 2.8681C11.6492 3.0438 12.3508 3.0438 13.0183 2.8681C13.7744 2.66904 14.463 2.15265 15.84 1.11988L16 0.999878M8 19.9999L7 21.9999M16 19.9999L17 21.9999M12.5 15.9999C12.5 16.276 12.2761 16.4999 12 16.4999C11.7239 16.4999 11.5 16.276 11.5 15.9999M12.5 15.9999C12.5 15.7237 12.2761 15.4999 12 15.4999C11.7239 15.4999 11.5 15.7237 11.5 15.9999M12.5 15.9999H11.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10.4C2 8.15979 2 7.03968 2.43597 6.18404C2.81947 5.43139 3.43139 4.81947 4.18404 4.43597C5.03968 4 6.15979 4 8.4 4H15.6C17.8402 4 18.9603 4 19.816 4.43597C20.5686 4.81947 21.1805 5.43139 21.564 6.18404C22 7.03968 22 8.15979 22 10.4V13.6C22 15.8402 22 16.9603 21.564 17.816C21.1805 18.5686 20.5686 19.1805 19.816 19.564C18.9603 20 17.8402 20 15.6 20H8.4C6.15979 20 5.03968 20 4.18404 19.564C3.43139 19.1805 2.81947 18.5686 2.43597 17.816C2 16.9603 2 15.8402 2 13.6V10.4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="3.99976"
				width="20"
				height="16"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M8 1L8.16 1.12C9.53703 2.15278 10.2256 2.66916 10.9817 2.86822C11.6492 3.04393 12.3508 3.04393 13.0183 2.86822C13.7744 2.66916 14.463 2.15278 15.84 1.12L16 1M8 20L7 22M16 20L17 22M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16M12.5 16C12.5 15.7239 12.2761 15.5 12 15.5C11.7239 15.5 11.5 15.7239 11.5 16M12.5 16H11.5M8.4 20H15.6C17.8402 20 18.9603 20 19.816 19.564C20.5686 19.1805 21.1805 18.5686 21.564 17.816C22 16.9603 22 15.8402 22 13.6V10.4C22 8.15979 22 7.03968 21.564 6.18404C21.1805 5.43139 20.5686 4.81947 19.816 4.43597C18.9603 4 17.8402 4 15.6 4H8.4C6.15979 4 5.03968 4 4.18404 4.43597C3.43139 4.81947 2.81947 5.43139 2.43597 6.18404C2 7.03968 2 8.15979 2 10.4V13.6C2 15.8402 2 16.9603 2.43597 17.816C2.81947 18.5686 3.43139 19.1805 4.18404 19.564C5.03968 20 6.15979 20 8.4 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.45 0.400047C8.11862 0.151519 7.64852 0.218676 7.4 0.550047C7.15147 0.881418 7.21862 1.35152 7.55 1.60005L8.66999 2.44005L8.79466 2.5336C9.16038 2.80817 9.48053 3.04852 9.77878 3.25L9.25 3.25C6.44974 3.25 5.04961 3.25 3.98005 3.79497C3.03924 4.27433 2.27433 5.03924 1.79497 5.98005C1.25 7.0496 1.25 8.44974 1.25 11.25L1.25 12.75C1.25 15.5503 1.25 16.9504 1.79497 18.02C2.27433 18.9608 3.03923 19.7257 3.98005 20.205C4.6788 20.5611 5.51866 20.6845 6.79785 20.7273L6.32917 21.6646C6.14393 22.0351 6.2941 22.4856 6.66459 22.6709C7.03507 22.8561 7.48557 22.7059 7.67082 22.3355L8.4638 20.7495C8.71302 20.75 8.97474 20.75 9.25 20.75L14.75 20.75C15.0253 20.75 15.287 20.75 15.5362 20.7495L16.3292 22.3355C16.5144 22.7059 16.9649 22.8561 17.3354 22.6709C17.7059 22.4856 17.8561 22.0351 17.6708 21.6646L17.2021 20.7273C18.4813 20.6845 19.3212 20.5611 20.0199 20.205C20.9608 19.7257 21.7257 18.9608 22.205 18.02C22.75 16.9504 22.75 15.5503 22.75 12.75L22.75 11.25C22.75 8.44974 22.75 7.04961 22.205 5.98005C21.7257 5.03924 20.9608 4.27434 20.02 3.79497C18.9504 3.25 17.5503 3.25 14.75 3.25L14.2212 3.25C14.5195 3.04852 14.8396 2.80817 15.2053 2.5336L15.33 2.44005L16.45 1.60005C16.7814 1.35152 16.8485 0.881418 16.6 0.550047C16.3515 0.218676 15.8814 0.151519 15.55 0.400047L14.43 1.24005C13.3438 2.05467 12.9636 2.32303 12.5728 2.42592C12.1973 2.52476 11.8027 2.52476 11.4272 2.42592C11.0364 2.32303 10.6562 2.05467 9.57 1.24005L8.45 0.400047ZM13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 10V9.5V9.5C22 8.10444 22 7.40666 21.8278 6.83886C21.44 5.56046 20.4395 4.56004 19.1611 4.17224C18.5933 4 17.8956 4 16.5 4H7.5C6.10444 4 5.40666 4 4.83886 4.17224C3.56046 4.56004 2.56004 5.56046 2.17224 6.83886C2 7.40666 2 8.10444 2 9.5V9.5V10M22 14V14.5V14.5C22 15.8956 22 16.5933 21.8278 17.1611C21.44 18.4395 20.4395 19.44 19.1611 19.8278C18.5933 20 17.8956 20 16.5 20H7.5C6.10444 20 5.40666 20 4.83886 19.8278C3.56046 19.44 2.56004 18.4395 2.17224 17.1611C2 16.5933 2 15.8956 2 14.5V14.5V14M8 1L8.16 1.12C9.53703 2.15278 10.2256 2.66916 10.9817 2.86822C11.6492 3.04393 12.3508 3.04393 13.0183 2.86822C13.7744 2.66916 14.463 2.15278 15.84 1.12L16 1M8 20L7 22M16 20L17 22M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16M12.5 16C12.5 15.7239 12.2761 15.5 12 15.5C11.7239 15.5 11.5 15.7239 11.5 16M12.5 16H11.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 1L8.16 1.12C9.53703 2.15278 10.2256 2.66916 10.9817 2.86822C11.6492 3.04393 12.3508 3.04393 13.0183 2.86822C13.7744 2.66916 14.463 2.15278 15.84 1.12L16 1M8 20L7 22M16 20L17 22M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16M12.5 16C12.5 15.7239 12.2761 15.5 12 15.5C11.7239 15.5 11.5 15.7239 11.5 16M12.5 16H11.5M8.4 20H15.6C17.8402 20 18.9603 20 19.816 19.564C20.5686 19.1805 21.1805 18.5686 21.564 17.816C22 16.9603 22 15.8402 22 13.6V10.4C22 8.15979 22 7.03968 21.564 6.18404C21.1805 5.43139 20.5686 4.81947 19.816 4.43597C18.9603 4 17.8402 4 15.6 4H8.4C6.15979 4 5.03968 4 4.18404 4.43597C3.43139 4.81947 2.81947 5.43139 2.43597 6.18404C2 7.03968 2 8.15979 2 10.4V13.6C2 15.8402 2 16.9603 2.43597 17.816C2.81947 18.5686 3.43139 19.1805 4.18404 19.564C5.03968 20 6.15979 20 8.4 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.25 20.75C6.44974 20.75 5.04961 20.75 3.98005 20.205C3.03924 19.7257 2.27433 18.9608 1.79497 18.02C1.25 16.9504 1.25 15.5503 1.25 12.75L1.25 11.25C1.25 8.44974 1.25 7.04961 1.79497 5.98005C2.27434 5.03924 3.03924 4.27433 3.98005 3.79497C5.04961 3.25 6.44974 3.25 9.25 3.25L14.75 3.25C17.5503 3.25 18.9504 3.25 20.02 3.79497C20.9608 4.27434 21.7257 5.03924 22.205 5.98005C22.75 7.04961 22.75 8.44974 22.75 11.25V12.75C22.75 15.5503 22.75 16.9504 22.205 18.02C21.7257 18.9608 20.9608 19.7257 20.02 20.205C18.9504 20.75 17.5503 20.75 14.75 20.75H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.39967 0.549802C7.6482 0.218431 8.1183 0.151274 8.44967 0.399802L9.56967 1.2398C10.6558 2.05443 11.036 2.32278 11.4269 2.42568C11.8024 2.52451 12.197 2.52451 12.5724 2.42568C12.9633 2.32278 13.3435 2.05443 14.4297 1.2398L15.5497 0.399802C15.881 0.151274 16.3511 0.218431 16.5997 0.549802C16.8482 0.881173 16.781 1.35127 16.4497 1.5998L15.3297 2.4398C15.2875 2.47141 15.246 2.5026 15.205 2.53336C14.294 3.21733 13.6657 3.68899 12.9543 3.87626C12.3285 4.04098 11.6708 4.04098 11.045 3.87626C10.3336 3.68899 9.70539 3.21733 8.79433 2.53336C8.75336 2.5026 8.71182 2.47141 8.66967 2.4398L7.54967 1.5998C7.2183 1.35127 7.15114 0.881173 7.39967 0.549802ZM7.83508 20.329C8.20557 20.5142 8.35573 20.9647 8.17049 21.3352L7.67049 22.3352C7.48525 22.7057 7.03475 22.8559 6.66426 22.6706C6.29378 22.4854 6.14361 22.0349 6.32885 21.6644L6.82885 20.6644C7.01409 20.2939 7.4646 20.1437 7.83508 20.329ZM16.1643 20.329C16.5347 20.1437 16.9853 20.2939 17.1705 20.6644L17.6705 21.6644C17.8557 22.0349 17.7056 22.4854 17.3351 22.6706C16.9646 22.8559 16.5141 22.7057 16.3289 22.3352L15.8289 21.3352C15.6436 20.9647 15.7938 20.5142 16.1643 20.329Z"
				fill="currentColor"
			/>
			<path
				d="M12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
